// import { Dropdown, Flex, Input, Menu, MenuProps, message, Radio, Space, Tooltip, Typography } from "antd";
import { Modal, Typography } from "antd";
import React, { FC, SetStateAction, useEffect, useState } from "react";
// import { SvgIcon } from "src/shared/icons";
import { useDispatch, useSelector } from "react-redux";
// import { closeAssigningArr, teamSelector, userSelector } from "src/store/user";
// import { ConfirmButtons, CustomSelect, Modal } from "src/components/ui";
// import { assignmentsToUpl, takeOffPopUpToUpdPros } from "src/store/outreach-campaigns/asyncRequests";

export const NotificationTeamStatus: React.FC = () => {
  const dispatch = useDispatch();

  return "";
  // <Modal open title={`Not added to a team`} zIndex={1000}>
  //   Are you sure you logged in with the correct email? Check with your
  //   <Typography.Paragraph
  //     className={"profile-menu-title"}
  //     onClick={() => {
  //       dispatch(logout({}));
  //       window.location.href = "/login";
  //     }}
  //     style={{ cursor: "pointer", fontSize: "13px" }}
  //   >
  //     Logout
  //   </Typography.Paragraph>
  // </Modal>
};
